import { Col, Row } from 'antd'
import React from 'react'
import OverviewChart from '../OverviewChart/OverviewChart'

const OverviewSource = ({ source, avaregDays, sourceLoading }) => {
    return (
        <div className='overview_source_avResp' style={{ width: "100%" }}>
            <Row gutter={36} >
                <Col lg={12} xs={24}  >
                    <OverviewChart option={source} title="Source" loading={sourceLoading} />
                </Col>
                <Col lg={12} xs={24}  >
                    <OverviewChart option={avaregDays} title="Average Response Time" />
                </Col>
            </Row>
        </div>
    )
}

export default OverviewSource